import { DecisionEngineApi } from 'api/Types';
import { getBranchInfoRequest } from 'BranchInfo/ActionCreator';
import Fetcher from 'middlewares/Fetcher';
import { AnyAction, Middleware, MiddlewareAPI } from 'redux';
import { updateScoringRuleSegmentFailure, updateScoringRuleSegmentSuccess } from './ActionCreator';
import { UPDATE_SCORING_RULE_SEGMENT, UPDATE_SCORING_RULE_SEGMENT_SUCCESS } from './ActionTypes';
import { CompletedScoringModelRequestData, UpdateScoringRuleSegmentAction } from './Types';

export const UpdateScoringRuleSegmentMiddleware: (api: DecisionEngineApi) => Middleware = (api) =>
  Fetcher<CompletedScoringModelRequestData, UpdateScoringRuleSegmentAction>(
    UPDATE_SCORING_RULE_SEGMENT,
    updateScoringRuleSegmentSuccess,
    updateScoringRuleSegmentFailure,
    async ({ payload }) => {
      await api.updateScoringRuleSegment(payload);
      return payload;
    },
  );

export const onUpdateScoringRueSuccessMiddleware: Middleware = ({ dispatch }: MiddlewareAPI<any>) => (
  next: (action: AnyAction) => any,
) => (action: AnyAction) => {
  const result = next(action);
  if (action.type === UPDATE_SCORING_RULE_SEGMENT_SUCCESS) {
    const { strategyId, moduleKey, branchIndex } = action.payload;
    dispatch(getBranchInfoRequest({ strategyId, moduleKey, branchIndex }));
  }
  return result;
};
